import { takeLatest } from "redux-saga/effects";

import { FIND_DOCUMENT } from "../ducks/iflow/actionTypes";

import { findDocument } from "../ducks/iflow/sagas";

export const iflowSagas = [takeLatest(FIND_DOCUMENT, findDocument)];
